<script>

	import './style.scss'

	export default {
		name: 'notification',
		props: [
			'show',
			'type',
			'message',
			'duration'
		],
		data: () => ({
			showNotif: false,
		}),
		updated () {
			this.showNotif = this.show;
			let that = this;
			if (this.show === true) {
				setTimeout(() => {
					that.$eventHub.$emit('notification', { show: false })
				}, this.duration);
			}
		},
		methods: {
			toggleNotif () {
				this.showNotif = false
			},
		}
	}
</script>

<template>
	<div :class='{ notification: true, show: showNotif === true, [type]: type }'>
		<div class='badge'>
			{{ type }}
		</div>
		<p v-html='message' />
		<div class='close' @click='$eventHub.$emit("notification", { show: false })'>
			<i class='ion-close' />
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Notification/Notification.vue